import { render, staticRenderFns } from "./ComplaintsSamples.vue?vue&type=template&id=77f69a1e"
import script from "./ComplaintsSamples.vue?vue&type=script&lang=js"
export * from "./ComplaintsSamples.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports